export const appVersion = window.APP_VERSION;
export const masterFormId = window.MASTER_FORM_ID;
export const productFormId = window.PRODUCT_FORM_ID;
export const productRoute = window.PRODUCT_ROUTE;
export const smallCropSize = window.SMALL_CROP_SIZE;
export const cropSizeList = window.CROP_SIZE_LIST;
export const siteTitle = window.SITE_TITLE;
export const userKind = window.USER_KIND;
export const skipRoutes = window.SKIP_ROUTES || [];